import { KEYS_SEPARATOR, KEY_VALUE_SEPARATOR, VALUES_SEPARATOR } from '../../config/constants'

export const stringifyFilterParams = (_filterParams) => {
  if (!_filterParams) return '';

  const _paramsArray = _filterParams.map(filter => {
    let value = '';

    // Stringify the filter.value(s) - start
    if (filter.value === null || filter.value === undefined) {
      value = ''
    } else if (['string', 'boolean'].includes(typeof filter.value)) {
      value = filter.value;
    } else if (Array.isArray(filter.value)) {

      const valueArray = filter.value.map(v => {
        if (v === null || v === undefined) {
          return ''
        }

        if (['string', 'boolean'].includes(typeof v)) {
          return v;
        }

        if (v.code) {
          return v.code
        }

        throw `Unexpected value type in '${filter.key}': ${filter.value}`
      });
      // Stringify the filter.value(s) - end
      value = valueArray.join(VALUES_SEPARATOR);

    } else if (filter.value.code) {
      value = filter.value.code;
    }

    return filter.key + KEY_VALUE_SEPARATOR + value
  })

  return _paramsArray.join(KEYS_SEPARATOR);
}